"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Hashtag = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        fillRule: "evenodd",
        d: "m15.067 7.968.97-3.467 2.205.001-.97 3.466H19.5l-.613 2.202h-2.232l-1.025 3.66h2.222l-.614 2.203h-2.224l-.97 3.467-2.205-.001.97-3.466H8.933l-.97 3.466-2.205-.001.97-3.465H4.5l.613-2.202h2.232l1.025-3.66H6.126l.613-2.203h2.247L9.957 4.5l2.204.001-.97 3.467h3.876Zm-.617 2.202h-3.876L9.55 13.83h3.876l1.024-3.66Z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Hashtag;
